import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'

import App from './App'
import { actionCreators as customerActionCreators } from '@/checkout-instore-legacy/customer/actions'
import { actionCreators as deviceActionCreators } from '@/checkout-instore-legacy/device/actions'
import { actionCreators as nativeActionCreators } from '@/checkout-instore-legacy/native/actions'
import { actionCreators as transferActionCreators } from '@/checkout-instore-legacy/transfer/actions'
import { actionCreators as altOrderActionCreators } from '@/checkout-instore-legacy/order/actions'
import { actionCreators as ordersActionCreators } from '@/checkout-instore-legacy/orders/actions'
import { actionCreators as vendorActionCreators } from '@/checkout-instore-legacy/vendor/actions'
import { actionCreators as rootModalActionCreators } from '@/checkout-instore-legacy/rootModal/actions'
import { actionCreators as globalTopMessageActionCreators } from '@/checkout-instore-legacy/globalTopMessage/actions'
import { actionCreators as ShareActionCreators } from '@/checkout-instore-legacy/share/actions'
import { transferDataSelector } from '@/checkout-instore-legacy/transfer/selectors'
import { vendorSelector } from '@/checkout-instore-legacy/vendor/selectors'

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeCustomer: customerActionCreators.changeCustomer,
      setAppInfo: nativeActionCreators.setAppInfo,
      setDeviceId: nativeActionCreators.setDeviceId,
      setCredentialsSuccess: nativeActionCreators.setCredentialsSuccess,
      setCredentialsError: nativeActionCreators.setCredentialsError,
      setCredentials: nativeActionCreators.setCredentials,
      updateTransferVendor: transferActionCreators.updateVendor,
      updateTransferCart: transferActionCreators.updateCart,
      updateTransferOrderFormId: transferActionCreators.updateOrderFormId,
      setCustomer: altOrderActionCreators.setCustomer,
      setClientProfileData: altOrderActionCreators.setClientProfileData,
      reloadOrderForm: altOrderActionCreators.reloadOrderForm,
      setAppVersion: nativeActionCreators.setAppVersion,
      logout: vendorActionCreators.logout,
      openRootModal: rootModalActionCreators.openCustomRootModal,
      openRootModalWithError: rootModalActionCreators.openRootModalWithError,
      newOrder: ordersActionCreators.newOrder,
      acknowledgeResources: deviceActionCreators.acknowledgeResources,
      dispatchNativeAppInfo: deviceActionCreators.dispatchNativeAppInfo,
      setGlobalTopMessage: globalTopMessageActionCreators.setGlobalTopMessage,
      clearGlobalTopMessage:
        globalTopMessageActionCreators.clearGlobalTopMessage,
      refreshAccountHostName: ShareActionCreators.refreshAccountHostName,
      setAppState: deviceActionCreators.setAppState,
    },
    dispatch
  )

const mapStateToProps = createStructuredSelector({
  transferData: transferDataSelector,
  vendor: vendorSelector,
})

export default connect(mapStateToProps, mapDispatchToProps)(App)
